import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// component
import { SortByIndex } from './sortByIndex.pipe';
import { SafePipe } from './safe.pipe';
import { SafeHtmlPipe } from './safeHTML.pipe';
import { DigitsOnlyDirective } from './digits-only.directive';


@NgModule({
  declarations: [
	SortByIndex,
    SafePipe,
    SafeHtmlPipe,
    DigitsOnlyDirective
  ],
  imports: [
	CommonModule
  ],
  exports: [
	SortByIndex,
    SafePipe,
    SafeHtmlPipe,
    DigitsOnlyDirective
  ]
})
export class SharedModule { }
